/** Метаданные imperative WebMCP tools (server + client). */

export type ImperativeWebMcpToolMeta = {
  name: string;
  description: string;
  readOnlyHint: boolean;
};

export const IMPERATIVE_WEBMCP_TOOL_META: ImperativeWebMcpToolMeta[] = [
  {
    name: "getPricing",
    description:
      "Актуальные публичные тарифы Идеалитика: цена в ₽, кредиты отчётов, фичи. Только данные API сайта — не выдумывать цены.",
    readOnlyHint: true,
  },
  {
    name: "getProductInfo",
    description:
      "Описание сервиса Идеалитика: позиционирование, 6 критериев scoring, режимы отчёта, FAQ и ключевые ссылки.",
    readOnlyHint: true,
  },
  {
    name: "listExampleReports",
    description:
      "Публичные примеры отчётов и llms.txt для ознакомления с форматом research-отчёта.",
    readOnlyHint: true,
  },
  {
    name: "navigateToCreateReport",
    description:
      "Открыть мастер создания research-отчёта. Требуется аккаунт; при отсутствии входа — редирект на login.",
    readOnlyHint: false,
  },
];

export const IDEALITIKA_WEBMCP_TOOL_NAMES = IMPERATIVE_WEBMCP_TOOL_META.map(
  (t) => t.name,
);
